module.exports = __webpack_public_path__ + "static/img/soc3.2bff6a18.jpg";